import React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import Dialog from '../../../BaseComponents/Dialog/EDDialog';
import ZoomableImage from './ZoomableImage';
import ZoomableImageToolbar from './ZoomableImageToolbar';
import { TransformWrapper, ReactZoomPanPinchState } from 'react-zoom-pan-pinch';

interface IProps {
  imageCount: number;
  imageIndex: number;
  isImage: boolean;
  nextImage: () => void;
  previousImage: () => void;
  showFullScreen: boolean;
  toggleCenteredImage: () => void;
  toggleFullScreen: () => void;
  title: string;
  subtitle?: string;
  hideTools?: boolean;
  showCenteredImageToggle?: boolean;
  noImageCount?: boolean;
  centeredImage?: boolean;
  navHeader: string;
  navHeaderEttGenus?: boolean;
  disableNavHeader?: boolean;
  rotation: number;
  rotateRight: () => void;
  rotateLeft: () => void;
  rotationReset: () => void;
  setPaperRef?: (element: HTMLDivElement) => void;
  children?: React.ReactNode;
  useWheelToScroll: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  dialogContentWrapper: {
    margin: 0,
    height: '100%',
  },
  dialogPaper: {
    height: '100%',
    [theme.breakpoints.up('md')]: {
      maxHeight: 'calc(100% - 16px)',
    },
  },
  dialogPaperScrollPaper: {},
  dialogContent: {
    height: '100%',
  },
});

class ZoomableImageFullscreen extends React.Component<IProps> {
  isAtDefault = (state: ReactZoomPanPinchState) => (): boolean => {
    const notZoomed = state.scale === 1;
    const notPanned = state.positionX === 0 && state.positionY === 0;
    return notZoomed && notPanned;
  };

  render() {
    return (
      <Dialog
        open={this.props.showFullScreen}
        onClose={this.props.toggleFullScreen}
        title={this.props.title}
        subtitle={this.props.subtitle}
        classes={{
          contentWrapper: this.props.classes.dialogContentWrapper,
          paper: this.props.classes.dialogPaper,
          paperScrollPaper: this.props.classes.dialogPaperScrollPaper,
          content: this.props.classes.dialogContent,
        }}
        maxWidth={false}
        fullWidth
        keepMounted
      >
        <TransformWrapper
          initialScale={1}
          limitToBounds={false}
          minScale={0.1}
          wheel={{ disabled: !this.props.useWheelToScroll }}
          doubleClick={{
            disabled: true,
          }}
        >
          {({ zoomIn, zoomOut, resetTransform, state, instance }) => (
            <ZoomableImage
              rotation={this.props.rotation}
              rotationReset={this.props.rotationReset}
              panning={instance.isPanning}
              toolbar={
                <ZoomableImageToolbar
                  defaultZoom={() => resetTransform()}
                  isAtDefault={this.isAtDefault(state)}
                  zoomIn={() => zoomIn()}
                  zoomOut={() => zoomOut()}
                  rotateRight={this.props.rotateRight}
                  rotateLeft={this.props.rotateLeft}
                  toggleCenteredImage={this.props.toggleCenteredImage}
                  toggleFullScreen={this.props.toggleFullScreen}
                  fullScreen={this.props.showFullScreen}
                  imageCount={this.props.imageCount}
                  imageIndex={this.props.imageIndex}
                  nextImage={this.props.nextImage}
                  previousImage={this.props.previousImage}
                  color="inherit"
                  showCenteredImageToggle={this.props.showCenteredImageToggle}
                  noImageCount={this.props.noImageCount}
                />
              }
              centered={this.props.centeredImage}
              setPaperRef={this.props.setPaperRef}
              itemCount={this.props.imageCount}
              itemIndex={this.props.imageIndex}
              isImage={this.props.isImage}
              navHeader={this.props.navHeader}
              navHeaderEttGenus={this.props.navHeaderEttGenus}
              onNextClick={this.props.nextImage}
              onPrevClick={this.props.previousImage}
              useWheelToScroll={this.props.useWheelToScroll}
            >
              {this.props.children}
            </ZoomableImage>
          )}
        </TransformWrapper>
      </Dialog>
    );
  }
}

export default withStyles(ZoomableImageFullscreen, styles);
